import { Theme, THEME_STORAGE_KEY } from './models/theme';
import { getPreferredTheme } from './utils/get-preferred-theme';
import { DOCUMENT } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
  output,
  signal,
} from '@angular/core';

@Component({
  selector: 'mop-theme-toggle',
  templateUrl: './theme-toggle.component.html',
  styleUrl: './theme-toggle.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ThemeToggleComponent implements OnInit {
  private readonly document = inject(DOCUMENT);

  currentTheme = signal<Theme>(getPreferredTheme());
  themeChanged = output<Theme>();

  ngOnInit() {
    window
      .matchMedia('(prefers-color-scheme: dark)')
      .addEventListener('change', ({ matches: isDark }) => {
        this.currentTheme.set(isDark ? 'dark' : 'light');

        this.setTheme(this.currentTheme());
      });
  }

  toggleTheme() {
    this.currentTheme.update((theme) => (theme === 'light' ? 'dark' : 'light'));

    this.setTheme(this.currentTheme());
    this.themeChanged.emit(this.currentTheme());
  }

  private setTheme(theme: Theme) {
    this.document.firstElementChild?.setAttribute('data-bs-theme', theme);
    localStorage.setItem(THEME_STORAGE_KEY, this.currentTheme());
  }
}
